import React from 'react';

interface Partner { src: string; name: string; cap?: number }

// Ordre + rendu conformes à la maquette de référence
const PARTNERS: Partner[] = [
  { src: '/partners/desjardins.png', name: 'Desjardins', cap: 150 },
  { src: '/partners/heetch.png', name: 'Heetch', cap: 66 },
  { src: '/partners/fleetch.jpg', name: 'Fleetch', cap: 150 },
  { src: '/partners/yango.png', name: 'Yango', cap: 120 },
  { src: '/partners/ada.jpg', name: 'ADA Luxembourg', cap: 80 },
  { src: '/partners/izili.png', name: 'Izili', cap: 92 },
  { src: '/partners/pnud.png', name: 'PNUD', cap: 54 },
];

const Partners: React.FC = () => (
  <section className="bg-white py-8 sm:py-12" aria-label="Partenaires de Proxy Emobility">
    <style>{`
      @keyframes partnersScroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }
      .partners-track { animation: partnersScroll 28s linear infinite; }
      .partners-marquee:hover .partners-track { animation-play-state: paused; }
      @media (prefers-reduced-motion: reduce) { .partners-track { animation: none; } }
    `}</style>
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="rounded-[20px] border border-[#ECECEC] bg-white px-5 py-5 shadow-[0_24px_70px_-40px_rgba(0,0,0,0.20)] sm:px-8 sm:py-6 lg:px-10">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:gap-8">
          {/* Libellé */}
          <div className="shrink-0 text-center lg:text-left">
            <p className="text-[12px] font-black uppercase leading-[1.4] tracking-[0.13em] text-neutral-900">
              Ils nous font
              <br />
              <span className="text-primary-600">confiance</span>
            </p>
          </div>

          {/* Filet séparateur (desktop) */}
          <div className="hidden h-12 w-px shrink-0 bg-neutral-200 lg:block" />

          {/* Logos posés directement — scroll (mobile) · wrap (tablette) · une ligne répartie (desktop) */}
          <div className="partners-marquee relative -mx-5 flex-1 overflow-hidden px-5 lg:mx-0 lg:px-0 [mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)]">
            <div className="partners-track flex w-max items-center gap-9 sm:gap-12">
              {[...PARTNERS, ...PARTNERS].map((p, i) => (
                <div key={`${p.name}-${i}`} className="flex shrink-0 items-center justify-center" aria-hidden={i >= PARTNERS.length}>
                  <img
                    src={p.src}
                    alt={i < PARTNERS.length ? `${p.name} — partenaire de Proxy Emobility` : ''}
                    loading="lazy"
                    decoding="async"
                    className="h-auto w-auto max-h-10 object-contain grayscale opacity-60 sm:max-h-12"
                    style={{ maxWidth: `${p.cap ?? 120}px` }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Partners;
